<div [formGroup]="formVisit">
    <div formArrayName="hexDiagnosis">
        @for (item of diagnosis.controls; track item; let i = $index) {
        <div [formGroupName]="i" class="flex-column">
            <div class="full-width">
                @if(showTitle) {
                <div class="full-width font-weight-500">
                    {{i+1 + '.'}} {{ 'medicalHistory.modify.diagnosis.title.label' | translate }}
                </div>
                }
                <div class="full-width d-flex">
                    @if (item) {
                    <diana-dropdown-diagnosis-keys class="full-width" [diagnosisList]="diagnosisList"
                        [diagnosisControls]="diagnosisFormArray" [indexFormDiagnosis]="i" [currentLanguage]="currentLanguage"
                        [isReadOnly]="isReadOnly" [formGroupDiagnosis]="getFormGroup(item)"
                        (typeIsChanged)="handleTypeChange()" [uniqueId]="i">
                    </diana-dropdown-diagnosis-keys>
                    }
                    @if (diagnosis && diagnosis.controls && diagnosis.controls.length > 1 && item) {
                    <div class="delete-button-area">
                        <button mat-icon-button class="icon-active" (click)="removeDiagnosis(i)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                    }
                </div>

            </div>

            <div class="full-width">
                @if (item && treatmentPrescriptions.length > 0){
                <diana-diagnosis-treatment-table
                    [treatmentPrescriptions]="treatmentPrescriptions" [diagnosis]="diagnosis"
                    [diagnosisWithTreatmentIndex]="i" [applicationTypes]="applicationTypes"
                    [servingModes]="servingModes" [diagnosisList]="diagnosisList" [visitAt]="visitAtControl.value"
                    [diagnosisWithTreatmentControl]="getFormGroup(item)" (typeIsChanged)="handleTypeChange()"
                    (changeDate)="handleShowCalendar($event)">
                </diana-diagnosis-treatment-table>
                }
            </div>
        </div>
        }
        @if (diagnosis.controls && diagnosis.controls.length < 3 && !isReadOnly && treatmentPrescriptions.length> 1) {
            <button mat-raised-button color="primary" (click)="addDiagnosis()" id="btnAddHexDiagnosis">
                {{ 'orgUnit.toaster.modify.diagnosis.button.addDiagnosis.label' | translate }}
            </button>
            }

    </div>
</div>
